'use client';

import { cn } from '@coas/ui/lib';
import { Slot } from '@radix-ui/react-slot';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { PropsOf } from '~/shared/lib';

type SidebarLinkProps<T extends boolean> = (T extends true ? PropsOf<typeof Link> : PropsOf<'a'>) & {
    asChild?: boolean;
};

export default <T extends boolean>({ className, asChild, ...props }: SidebarLinkProps<T>) => {
    const Comp = asChild ? Slot : Link;
    const pathname = usePathname();
    const url = typeof props.href === 'string' ? props.href : props.href?.pathname;

    return (
        <li>
            {/* @ts-expect-error */}
            <Comp
                data-active={url && pathname.startsWith(url)}
                aria-current={url && pathname.startsWith(url) ? 'page' : undefined}
                className={cn(
                    'group flex w-full items-center justify-start gap-x-4 border-l-4 p-page-1/2',
                    url && pathname.startsWith(url) ? 'border-blue-400 bg-neutral-100' : 'border-transparent',
                    className,
                )}
                {...props}
            />
        </li>
    );
};
